import { useEffect, useState } from "react";
import FormControl from "../../gui/Form/FormControl";
import Validators from "../../gui/Form/Validators";
import { UpdateEvent } from "../../gui/GUIEvents";
import TextInput from "../../gui/TextInput/TextInput";
import { TFoodEntry } from "../../shared/Meals";
import FoodEntryList from "./FoodEntryList";
import { Formatters } from "../../gui/TextInput/TextInput";
import Dropdown from "../../gui/Dropdown/Dropdown";
import { TUnits } from "../../shared/Recipes";
import { IconButton } from "@mui/material";
import DeleteIcon from "../../gui/Icons/DeleteIcon";

export type TMealRowProps = {
    index:number
    entry:TFoodEntry
    onUpdate:(index:number, entry:TFoodEntry) => void
    onDelete:(index:number) => void
}
export default function MealRow(props:TMealRowProps){
    const [foodId,setFoodId] = useState<string|number>(props.entry.id)
    const [amount,setAmount] = useState<string>(props.entry.amount ? props.entry.amount.toString() : "")
    const [unit,setUnit] = useState<string>(props.entry.unit || "g")
    const isRecipe = typeof(foodId) == "string"

    useEffect(() => {
        props.onUpdate(props.index, {id:foodId,amount:parseFloat(amount)||0,unit:isRecipe ? undefined : unit as any})
    }, [foodId, amount, unit])

    const onRecipe = (e:UpdateEvent<string|number>) => e.value && setFoodId(e.value)
    const onAmount = (e:UpdateEvent<string>) => setAmount(e.value!)
    const onUnit = (e:UpdateEvent<string>) => e.value && setUnit(e.value)
    const onDelete = () => props.onDelete(props.index)

    return <div className="row">
        <FormControl validators={[Validators.Required("Food")]}><FoodEntryList index={props.index} foodId={props.entry.id} onUpdate={onRecipe}/></FormControl>
        <FormControl validators={[Validators.PositiveNumber("Amount", "Required", "Required")]}>
            <TextInput onUpdate={onAmount} value={amount} formatter={Formatters.PositiveRealNumber} placeholder="Amount"/>
        </FormControl>
        {isRecipe ? <div className="pt-16">Portion</div> : <Dropdown options={TUnits} value={unit} onUpdate={onUnit}/>}
        <IconButton onClick={onDelete}><DeleteIcon/></IconButton>
    </div>
}